import React from "react";
import { useParams } from "react-router-dom";
import { usePaperBillSummary } from "../../hooks";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { Calendar, Printer,Clock } from "lucide-react";
import { Alert } from "@shared/ui/alert";

const PaperBillDistributionDashboard = () => {
  const params = useParams();
  const { data: summaryData, isLoading: summaryLoading } = usePaperBillSummary(
    params.id
  );

  const statsData = [
    {
      title: "Total Bills",
      count: summaryData?.totalBills || 0,
      icon: <Printer className="h-8 w-8 text-blue-500" />,
      trendSummary: "Total paper bills to be printed",
    },
    {
      title: "Assigned Bills",
      count: summaryData?.assignedBills || 0,
      icon: <Calendar className="h-8 w-8 text-green-500" />,
      trendSummary: "Bills assigned to distributors",
    },
    {
      title: "Successfully Distributed",
      count: summaryData?.successfullyDistributed || 0,
      icon: <Calendar className="h-8 w-8 text-orange-500" />,
      trendSummary: "Bills successfully delivered",
    },
    {
      title: "Distribution Pending",
      count: summaryData?.distributionPending || 0,
      icon: <Clock className="h-8 w-8 text-red-500" />,
      trendSummary: "Bills awaiting delivery",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          icon={stat.icon}
          trendSummary={stat.trendSummary}
          trendDirection={stat.trendDirection}
        />
      ))}
    </div>
  );
};

export default PaperBillDistributionDashboard;
